export enum TC_BUTTON_TYPE {
    PRIMARY = "PRIMARY",
    SECONDARY = "SECONDARY",
    THIRDARY = "THIRDARY",
    DESTRUCTIVE = "DESTRUCTIVE",
    LISMA = "LISMA"
}

export const TC_BUTTON_STATUS = {
    LOADING: "LOADING",
    
}